import { selectors as authSelectors } from 'state/auth';
import { useSelector } from 'react-redux';
import { serialize } from 'utils/urls';
import config from 'config';
import { i18n } from 'i18n';

export function useSupersetDashboard(dashboard) {
  const shipperAuth = useSelector(authSelectors.getSuperSetAuth);
  const { language } = i18n;
  const lng = language.split('-')[0].toUpperCase();
  const params = serialize({
    token: config.SUPERSET_TOKEN,
    shipper_auth: shipperAuth,
    dashboard: dashboard,
    language: lng,
  });

  return `${config.SUPERSET_URL}?${params}`;
}
